import { CountryDto } from './country.dto';

export class BankAccountDto {
  id: number;
  name: string;
  code: string;
  countryId?: number;
  country?: CountryDto;
  isDefault?: boolean;
  swift?: string;
  agency: string;
  number: string;
  bank: string;
}

export class IntermediaryAccountDto {
  id: number;
  countryId: number;
  country: CountryDto;
  city: string;
  name: string;
  swift: string;
  number: string;
  aba: string;
  bank: string;
}

export class SendAccountReceiverDto {
  orderId?: number;
  name: string;
  code: string;
  agency: string;
  number: string;
}
